import { render, staticRenderFns } from "./feedback-box.vue?vue&type=template&id=40293f47&"
import script from "./feedback-box.vue?vue&type=script&lang=ts&"
export * from "./feedback-box.vue?vue&type=script&lang=ts&"
import style0 from "./feedback-box.vue?vue&type=style&index=0&id=40293f47&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports